import React, { useContext } from "react";
import {
  Caption,
  Card,
  Collapsible,
  ColorPicker,
  Layout,
  Stack,
  TextField,
  TextStyle,
  TextContainer,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const BackGround = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, BACKGROUND, DEFAULT_BACKGROUND_COLOR, DEFAULT_CONTENT_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.backgroundColor.title")}
        description={cms("section.backgroundColor.description")}
      >
        <Card
          title={[
            cms("section.backgroundColor.title"),
            updatedAt && (
              <TextStyle variation="subdued">
                <Caption>{`${baseHelper.lastUpdateDate(updatedAt)}`}</Caption>
              </TextStyle>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.headerColor.title"), "TODO: ") }]}
        >
          <Card.Section>
            <TextContainer>{cms("section.backgroundColor.subDescription")}</TextContainer>
            <br />
            <Stack>
              <Stack.Item fill>
                <TextField
                  label={cms("section.backgroundColor.label.hexCode")}
                  value={hex.backgroundHex}
                  onChange={(value) => handleChange(BACKGROUND, value, HEX)}
                  labelAction={
                    hex.backgroundHex !== DEFAULT_BACKGROUND_COLOR && {
                      content: cms("label.reset"),
                      onClick: () => resetDefault(BACKGROUND, DEFAULT_BACKGROUND_COLOR, HEX),
                    }
                  }
                  error={errorMessage && errorMessage.background}
                />
                <br />
                <TextStyle>
                  <div
                    style={{
                      width: "120px",
                      height: "50px",
                      background: hex.backgroundHex,
                      color: DEFAULT_CONTENT_COLOR,
                      textAlign: "center",
                      paddingTop: "13px",
                    }}
                  >
                    {cms("section.backgroundColor.label.sampleHeader")}
                  </div>
                </TextStyle>
              </Stack.Item>
              <Stack.Item>
                <ColorPicker
                  onChange={(value) => handleChange(BACKGROUND, value, COLOR)}
                  color={color.backgroundColor}
                />
              </Stack.Item>
            </Stack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(BackGround);
